import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// 1. Create the context
const FillingContext = createContext();

// 2. Create a custom hook for easier access
export const useFilling = () => useContext(FillingContext);

// 3. Provider component
export const FillingProvider = ({ children }) => {
  const [fillings, setFillings] = useState([]);

  // Function to fetch today's fillings
  const fetchFillings = async () => {
    try {
      const res = await axios.get('/api/fillings/');
      setFillings(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('❌ Error fetching fillings:', err);
    }
  };

  // Fetch on mount
  useEffect(() => {
    fetchFillings();
    const interval = setInterval(fetchFillings, 10000); // optional auto-refresh every 10s
    return () => clearInterval(interval);
  }, []);

  return (
    <FillingContext.Provider
      value={{
        fillings,
        setFillings,
        refreshFillings: fetchFillings,
      }}
    >
      {children}
    </FillingContext.Provider>
  );
};
